module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/apps/asna/front-end/public_html/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main